import historyRouter from '../../../../dist/vendor/instantsearch.js/es/lib/routers/history.js';
import { opts } from '../opts.js';
import { debounce } from './helpers.js';
import { setUiState, windowTitle } from './state.js';

const { indexName, searchParam } = opts.base;
const facets = opts.facets;
export const categorySlug = name => name.split(' ').map(encodeURIComponent).join('+');
export const categoryName = slug => slug.split('+').map(decodeURIComponent).join(' ');
export const debouncedUiState = debounce(setUiState, 500);

export const createUrl = ({ qsModule, routeState, location }) => {
	// const urlParts = isSearchPage ? location.href.match(/^(.*?)\/site-search/) : [];
	const state = routeState[indexName];
	const params = {};

	if (!state) {
		return
	}

	if (state[searchParam]) {
		params[searchParam]= encodeURIComponent(state[searchParam]);
  	}

	if (state.page > 1) {
		params.page = state.page;
	}

	if (state.menu && facets) {
		Object.keys(state.menu).forEach(attr => {
			const { slug } = facets.find(({ attribute }) => attribute === attr);
			params[slug] = encodeURIComponent(state.menu[attr]);
		});
	}

	const qs = qsModule.stringify(params, {
		addQueryPrefix: true,
		arrayFormat: 'repeat'
	});

	const url = `${window.location.origin}/site-search/${qs}`;

	return url;
}


export const parseUrl = ({ qsModule, location }) => {
	const route = qsModule.parse(location.search.slice(1));
	const state = {
		page: route.page ?? 1,
		[searchParam]: route[searchParam],
		menu: {}
	};

	facets && facets.forEach(({ slug, attribute }) => {
		if(route[slug]) {
			state.menu[attribute] = decodeURIComponent(route[slug]);
		}
	});

	return {
		[indexName]: state
	}
}


export const router = historyRouter({
	writeDelay: 500,
	cleanUrlOnDispose: true,
	windowTitle(routeState) {
		return windowTitle(routeState);

	},
	parseURL({ qsModule, location }) {
		return parseUrl({ qsModule, location });
	},
	createURL({ qsModule, routeState, location }) {
		return createUrl({ qsModule, routeState, location });
	}
});
